/* eslint-disable @typescript-eslint/no-unused-vars */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { phoneCasesEndPoints } from 'api/phoneCases/constants';
import {
  TPhoneCaseBEItem,
  TPhoneCaseByIdBE,
  TPhoneCasesCreateBE,
  TPhoneCasesCreateBody,
  TPhoneCasesDeleteBE,
  TPhoneCasesGetListBE,
  TPhoneCasesGetListQueryParams,
  TPhoneCasesToggleActiveBE,
  TPhoneCasesUpdateBE,
  TPhoneCasesUpdateBody,
} from 'api/phoneCases/phoneCases.types';
import createHttpClient from 'store/httpClient';
import { TStore } from 'store/store.types';
import { fromObjectToQueryString, objectToFormData } from 'utils/api';

export const getPhoneCasesListAsyncThunk = createAsyncThunk<
  TPhoneCasesGetListBE['data'],
  { queryParams: TPhoneCasesGetListQueryParams }
>('phoneCases/getList', async ({ queryParams }, { rejectWithValue }) => {
  try {
    const httpClient = createHttpClient(undefined);

    const response = await httpClient.get<TPhoneCasesGetListBE>(
      phoneCasesEndPoints.getList(fromObjectToQueryString(queryParams))
    );

    // console.log(getState() as TStore);
    // const {
    //   phoneCases: {
    //     phoneCasesList: { data: previousData },
    //   },
    // } = getState() as TStore;

    // const previousQuery =
    //   previousData?.data?.pagination?.prevPagination || {};

    // console.log(previousData);
    // console.log(response);
    // const {
    //   phoneCases: {
    //     phoneCasesList: {
    //       data: {
    //         data: {
    //           items,
    //           pagination: { prevPagination },
    //         },
    //       },
    //     },
    //   },
    // } = getState() as TStore;

    // console.log(items);

    return response.data;
  } catch (_) {
    return rejectWithValue({ message: 'Error fetching phone cases list' });
  }
});

// ---------------- GET BY ID ----------------

export const getPhoneCaseByIdAsyncThunk = createAsyncThunk<
  TPhoneCaseByIdBE['data'],
  { id: string }
>('phoneCases/getById', async ({ id }, { rejectWithValue }) => {
  try {
    const httpClient = createHttpClient(undefined);

    const response = await httpClient.get<TPhoneCaseByIdBE>(
      phoneCasesEndPoints.getById(id)
    );

    return response.data;
  } catch (_) {
    return rejectWithValue(null);
  }
});

// ---------------- CREATE ----------------

export const createPhoneCaseAsyncThunk = createAsyncThunk<
  TPhoneCasesCreateBE['data'],
  { body: TPhoneCasesCreateBody; onSuccess?: () => void }
>('phoneCases/create', async ({ body, onSuccess }, { rejectWithValue }) => {
  try {
    const httpClient = createHttpClient(undefined);
    const formData = objectToFormData(body);
    const response = await httpClient.post<TPhoneCasesCreateBE, FormData>(
      phoneCasesEndPoints.create(),
      formData
    );

    if (onSuccess) {
      onSuccess();
    }

    return response.data;
  } catch (_) {
    return rejectWithValue(null);
  }
});

// ---------------- UPDATE ----------------

export const updatePhoneCaseAsyncThunk = createAsyncThunk<
  TPhoneCasesUpdateBE['data'],
  { id: string; body: TPhoneCasesUpdateBody; onSuccess?: () => void }
>('phoneCases/update', async ({ id, body, onSuccess }, { rejectWithValue }) => {
  try {
    console.log(body);
    const httpClient = createHttpClient(undefined);
    const formData = objectToFormData(body);
    const response = await httpClient.put<TPhoneCasesUpdateBE, FormData>(
      phoneCasesEndPoints.update(id),
      formData
    );

    if (onSuccess) {
      onSuccess();
    }

    return response.data;
  } catch (_) {
    return rejectWithValue(null);
  }
});

// ---------------- DELETE ----------------

export const deletePhoneCaseAsyncThunk = createAsyncThunk<
  TPhoneCasesDeleteBE['data'],
  { id: string; onSuccess?: () => void }
>('phoneCases/delete', async ({ id, onSuccess }, { rejectWithValue }) => {
  try {
    const httpClient = createHttpClient(undefined);

    const response = await httpClient.patch<TPhoneCasesDeleteBE>(
      phoneCasesEndPoints.delete(id)
    );

    if (onSuccess) {
      onSuccess();
    }
    return response.data;
  } catch (_) {
    return rejectWithValue(null);
  }
});

export const togglePhoneCaseActiveAsyncThunk = createAsyncThunk<
  TPhoneCasesToggleActiveBE['data'],
  { id: string; onSuccess?: () => void }
>('phoneCases/toggleActive', async ({ id, onSuccess }, { rejectWithValue }) => {
  try {
    const httpClient = createHttpClient(undefined);

    const response = await httpClient.patch<TPhoneCasesToggleActiveBE>(
      phoneCasesEndPoints.toggleActive(id)
    );

    if (onSuccess) {
      onSuccess();
    }

    return response.data;
  } catch (_) {
    return rejectWithValue(null);
  }
});
